import { BB_DATE_RE } from './config';

const DAY_MS = 86_400_000;

/** A YYYY-MM-DD store day as "Thu, Oct 29" ('long': "October 29", the
 * buy page's "Ships by" format). Read at UTC noon so no time
 * zone can move it to another day. A date already past (a cart left for
 * days) shows nothing: checkout holds again and gets a fresh date. One day
 * of slack covers US stores behind UTC. */
export const formatPickupDate = (
  date: string,
  locale: string,
  style: 'short' | 'long' = 'short',
): string | null => {
  if (!BB_DATE_RE.test(date)) return null;
  const at = new Date(`${date}T12:00:00Z`);
  if (Number.isNaN(at.getTime())) return null;
  const yesterday = new Date(Date.now() - DAY_MS).toISOString().slice(0, 10);
  if (date < yesterday) return null;
  return at.toLocaleDateString(
    locale,
    style === 'long'
      ? { month: 'long', day: 'numeric', timeZone: 'UTC' }
      : { weekday: 'short', month: 'short', day: 'numeric', timeZone: 'UTC' },
  );
};
